export const getPageMenuItemStyles = (pageMenuItem, { palette = {} }) => ({
  baseMenuItem: {
    color: 'rgba(0, 0, 0, 0)', // Hides the fallback glyph
    fontFamily: 'Segoe UI',
    fontWeight: 'normal',
    lineHeight: 'normal',
    display: 'flex',
    flexDirection: 'row',
    padding: '0 12px 0 0',
    textDecoration: 'none',
    cursor: 'pointer',
  },
  pageMenuItem: {
    '&:hover': {
      backgroundColor: palette.neutralLight,
      textDecoration: 'none',
      color: 'rgba(0,0,0,0.6)',
    },
    '&:active': {
      backgroundColor: palette.neutralQuaternaryAlt,
      textDecoration: 'none',
    },
  },
  notEnabledPageMenuItem: {
    '&:hover': {
      color: palette.themePrimary,
    },
    '&:active': {
      color: palette.themePrimary,
    },
    '&:focus': {
      color: palette.themePrimary,
    },
  },
  selectedPageMenuItem: {
    fontWeight: 600,
    backgroundColor: palette.themeLighter,
    '&:hover': {
      backgroundColor: palette.themeLight,
      textDecoration: 'none',
      color: palette.themePrimary,
    },
    '& a:focus': {
      textDecoration: 'none',
    },
    '& .fallback-glyph': {
      color: 'rgba(0,0,0,0.6)',
    },
  },
  notEnabledSelectedPageMenuItem: {
    color: palette.themePrimary,
  },
  beforeIcon: {
    borderLeft: `4px solid ${palette.themePrimary}`,
    padding: 0,
    marginRight: -4,
    alignSelf: 'stretch',
  },
  textContainer: {
    display: 'inline-block',
    marginLeft: 16,
    marginTop: 8,
    marginBottom: 9,
    wordBreak: 'break-word',
    flex: '1 1 1px',
    color: palette.neutralPrimary,
    '& a .page-menu-item-content': {
      '@media screen and (forced-colors: active)': {
        color: 'canvasText',
      },
    },
  },
  iconContainer: {
    display: 'inline-block',
    marginLeft: 16,
    marginTop: 8,
    marginBottom: 9,
    color: palette.neutralPrimary,
  },
  text: {
    fontSize: 14,
    color: palette.neutralPrimary,
  },
  fallbackGlyph: {
    fontSize: 16,
    color: 'inherit',
    float: 'right',
    padding: '7px 5px 10px 4px',
    lineHeight: '19px',
  },
  calloutTargetContainer: {
  },
  selectedLandingPage: {
    color: `${palette.themePrimary} !important`,
  },
  notSelectedLandingPage: {
    color: '#808080', // grey color
  },
  landingPageButton: {
    '&:focus': {
      outline: `1px solid ${palette.neutralSecondary}`,
    },
  },
  menuItemTagContainer: {
    position: 'absolute',
    display: 'inline-block',
    marginTop: '-14px',
    marginLeft: '-18px',
  },
  relationLine: {
    borderRight: `3px solid ${palette.neutralQuaternaryAlt}`,
    marginRight: -3,
    marginTop: -10,
  },
});
